<script lang="ts">
    import { COMMON__Recently_viewed_translations } from "@app/services/i18n.messages";
    import { getMessage } from "@app/services/i18n.service";
    import Breadcrumbs from "../Breadcrumbs/Breadcrumbs.svelte";
    import { homeBreadcrumbItem, myFavoriteTranslationsBreadcrumbItem, myGlosbeBreadcrumbItem, setBreadcrumbs } from "../Breadcrumbs/breadcrumbs.store";
    import RecentlyViewedTranslationsPresenter from "./RecentlyViewedTranslationsPresenter.svelte";

    setBreadcrumbs([
        homeBreadcrumbItem(),
        myGlosbeBreadcrumbItem(),
        myFavoriteTranslationsBreadcrumbItem(),
    ]);

</script>

<svelte:head>
    <title>{getMessage(COMMON__Recently_viewed_translations)} | Glosbe</title>
</svelte:head>

<div class="m-auto text-xs text-slate-600 py-2 max-w-76 px-2">
    <Breadcrumbs />
</div>
<div class="max-w-2xl p-2 m-auto">
    <h1 class="text-xl md:text-2xl mb-6 font-medium">
        {getMessage(COMMON__Recently_viewed_translations)}
    </h1>

    <RecentlyViewedTranslationsPresenter />
</div>
